/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable function-paren-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { AlertAdapter, Loader, RegularButton } from 'pg-ui-library';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';
import fallbackImageUrl from 'src/assets/empty_photo_benefit.jpg';

import { IBenefitType } from 'src/interfaces';
import './index.css';
import {
  GalleryCardImg,
  GalleryHeader,
  GalleryScrollableContainer,
  GalleryWrapper,
  EmptyGalleryContainer,
  FallbackImg,
  FormWrapper,
  FooterButtonWrapper,
} from './styles';

type BenefitFormType = {
  name: string;
  fileName?: string;
  files?: FileList | null;
  imgKey?: string;
};

export const BenefitForm: React.FC<{
  selectedBenefitType: IBenefitType | undefined;
  onClose: Function;
}> = ({ selectedBenefitType, onClose }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const schema = yup.object({
    name: yup.string().required(t('global.form.required')).max(255),
    files: yup.mixed().test('type', 'We only support pdf', value => {
      if (value) {
        let allValid = true;
        for (let index = 0; index < value.length; index++) {
          const file = value[index];
          if (file.type !== 'application/pdf') {
            allValid = false;
          }
        }
        return allValid;
      }
      return true;
    }),

    fileName: yup.string(),
  });

  const { isFetching, data: imgGallery } = useQuery(['benefits/images'], async () => {
    const result = await BenefitsService.getBenefitsImgGallery();
    return result;
  });

  const save = async (values: BenefitFormType) => {
    const fd = new FormData();
    if (values.files) {
      for (let index = 0; index < values.files.length; index++) {
        const file = values.files.item(index);
        if (file) {
          fd.append('files', file, file?.name || '');
        }
      }
    }
    if (values.imgKey) {
      fd.append('imgKey', values.imgKey);
    }

    fd.append('type', selectedBenefitType?.type || '');
    BenefitsService.editBenefit(fd).then(
      () => {
        queryClient.invalidateQueries({ queryKey: ['benefits/types'] });
        AlertAdapter('Benefits edited successfully', 'success');
        onClose();
      },
      (e: Error) => {
        AlertAdapter(e.message, 'error');
      }
    );
  };

  const mutationCreate = useMutation((variables: BenefitFormType) => save(variables));

  const onSubmit = async (values: BenefitFormType) => {
    await mutationCreate.mutateAsync(values);
  };

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    // eslint-disable-next-line no-param-reassign
    event.currentTarget.src = fallbackImageUrl;
  };

  return (
    <Formik
      initialValues={{
        name: selectedBenefitType?.type ?? '',
        file: null,
        fileName: '',
        // imgKey: selectedBenefitType?.imgURL ?? '',
        imgKey: '',
      }}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, values, isValid, setFieldValue }) => (
        <Form
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <FormWrapper>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: '1',
                marginTop: '20px',
              }}
            >
              <GalleryWrapper>
                <GalleryHeader>{t('benefits.editModal.gallery.title')}</GalleryHeader>
                <GalleryScrollableContainer>
                  {isFetching ? (
                    <EmptyGalleryContainer>
                      <Loader />
                    </EmptyGalleryContainer>
                  ) : (
                    imgGallery?.map(galleryImg => (
                      <GalleryCardImg
                        key={galleryImg.key}
                        onClick={() => {
                          setFieldValue('imgKey', galleryImg.key);
                        }}
                        selected={values.imgKey === galleryImg.key}
                      >
                        <FallbackImg src={galleryImg.url} alt="Fallback Image" onError={handleImageError} />
                      </GalleryCardImg>
                    ))
                  )}
                  {imgGallery === undefined && !isFetching && (
                    <EmptyGalleryContainer>
                      <p>{t('benefits.editModal.gallery.empty')}</p>
                    </EmptyGalleryContainer>
                  )}
                </GalleryScrollableContainer>
              </GalleryWrapper>
            </div>
          </FormWrapper>
          <FooterButtonWrapper>
            <div>
              <RegularButton
                data-cy="benefit-modal-submit-button"
                type="button"
                disabled={isSubmitting}
                onClick={() => {
                  if (!isValid) {
                    AlertAdapter('You need to fill name and a valid pdf document', 'warning');
                    return;
                  }
                  onSubmit(values);
                }}
              >
                {t('global.form.save')}
              </RegularButton>
            </div>
          </FooterButtonWrapper>
        </Form>
      )}
    </Formik>
  );
};
